import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { analyticsAPI } from '../../services/api';
import './AuditPage.css';

const ACTION_COLORS = {
  CREATE_DEPARTMENT: 'badge-success',
  UPDATE_DEPARTMENT: 'badge-accent',
  DELETE_DEPARTMENT: 'badge-danger',
};

export default function AuditPage() {
  const [logs, setLogs]     = useState([]);
  const [total, setTotal]   = useState(0);
  const [page, setPage]     = useState(1);
  const [loading, setLoading] = useState(true);
  const limit = 20;

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await analyticsAPI.getAuditLogs({ page, limit });
        setLogs(res.data.logs);
        setTotal(res.data.total);
      } catch {
        toast.error('Failed to load audit logs');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [page]);

  const totalPages = Math.ceil(total / limit);

  return (
    <div className="page-container" style={{ paddingTop: 32, paddingBottom: 48 }}>
      <div className="page-header">
        <h1>Audit Logs</h1>
        <p className="text-muted">Track all admin actions and changes.</p>
      </div>

      <div className="card animate-fade">
        {loading ? (
          <div className="flex-center" style={{ height: 200 }}><div className="spinner" /></div>
        ) : (
          <>
            <div className="audit-table-wrap">
              <table className="audit-table">
                <thead>
                  <tr>
                    <th>Timestamp</th>
                    <th>Admin</th>
                    <th>Action</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map((log) => (
                    <tr key={log.id}>
                      <td className="audit-time">
                        {new Date(log.created_at).toLocaleString()}
                      </td>
                      <td>
                        <div className="audit-admin">
                          <span className="audit-admin-name">{log.admin_name || 'Unknown'}</span>
                          <span className="text-small text-muted">{log.admin_email}</span>
                        </div>
                      </td>
                      <td>
                        <span className={`badge ${ACTION_COLORS[log.action] || 'badge-primary'}`}>
                          {log.action.replace(/_/g, ' ')}
                        </span>
                      </td>
                      <td className="audit-details">
                        {log.details ? (
                          <code>{JSON.stringify(log.details)}</code>
                        ) : '—'}
                      </td>
                    </tr>
                  ))}
                  {logs.length === 0 && (
                    <tr>
                      <td colSpan={4} className="text-center text-muted" style={{ padding: 40 }}>
                        No audit logs yet
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="audit-pagination">
                <span className="text-small text-muted">{total} records</span>
                <div className="pagination-btns">
                  <button
                    className="btn btn-ghost btn-sm"
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    disabled={page === 1}
                  >← Prev</button>
                  <span className="text-small">Page {page} of {totalPages}</span>
                  <button
                    className="btn btn-ghost btn-sm"
                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                    disabled={page === totalPages}
                  >Next →</button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <div><p className="login-footer">
              &copy; 2026 All Rights Reserved. <br />Credits to <a href="https://www.linkedin.com/in/narasimhapuli/" target='_blank'>V L Narasimha Rao PULI</a><br /><strong>Digital Applications Development Unit</strong> <br />BITS Pilani, Hyderabad Campus.
            </p></div>
    </div>
  );
}
